import clsx from "clsx";
import { PhotoLabTalentStatusEnum, PhotoLabTalentStatusLabel } from "@/api/photoLabTalent/models";
import { Popover } from "@/components/common/Popover";

type Props = {
  status: PhotoLabTalentStatusEnum;
};

const statusClassName: Record<PhotoLabTalentStatusEnum, string> = {
  [PhotoLabTalentStatusEnum.WAITING_MATERIAL]: "bg-error",
  [PhotoLabTalentStatusEnum.READY_FOR_CASTING]: "bg-success",
};

const StatusCircle = ({ status }: Props) => {
  return (
    <div
      aria-label={PhotoLabTalentStatusLabel[status]}
      className={clsx("min-h-[14px] min-w-[14px] rounded-full", statusClassName[status])}
      role="status"
    />
  );
};

export const PhotoLabTalentStatus = ({ status }: Props) => {
  return (
    <Popover
      actionIcon={<StatusCircle status={status} />}
      actionButtonProps={{ className: "!min-h-[auto] !p-0 !gap-0" }}
      contentClassName="rounded-[2px] border-2 border-background-secondary px-2 py-1"
      placement="top-end"
      onHover
    >
      {PhotoLabTalentStatusLabel[status]}
    </Popover>
  );
};
